import axios from 'axios';

const axiosInstance = axios.create({
  //baseURL: 'https://mscurie.qualitance.com/api/v1/',
  baseURL: '/api/v1/',
  //baseURL: 'http://46.97.77.90:3000/api/v1/',
  timeout: 10000,
});

export default axiosInstance;
